import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

// Mount only the selected, visible clip. No inactive video src is attached.
const MediaVideo = ({ src, poster, autoPlay, label }) => {
  const ref = useRef(null)
  useEffect(() => {
    const video = ref.current
    const reducedMotion = window.matchMedia?.(
      '(prefers-reduced-motion: reduce)',
    ).matches
    if (autoPlay && !reducedMotion) {
      const play = video?.play()
      // Native controls remain available if autoplay is refused by the browser.
      play?.catch(() => {})
    }
    return () => video?.pause()
  }, [src, autoPlay])
  return (
    <video
      ref={ref}
      src={src}
      poster={poster || undefined}
      controls
      playsInline
      loop
      muted={autoPlay}
      preload="metadata"
      aria-label={label}
      className="pdp-gallery-video"
    />
  )
}
MediaVideo.defaultProps = { poster: '', autoPlay: false }
MediaVideo.propTypes = {
  src: PropTypes.string.isRequired,
  poster: PropTypes.string,
  autoPlay: PropTypes.bool,
  label: PropTypes.string.isRequired,
}
export default MediaVideo
